module.exports = __webpack_public_path__ + "img/shank button diameter.386fb41b.png";